import { Injector } from '@angular/core';

import { epicDependencies } from '../store';

export const epicModuleInjectorTokenContainer = {};

export const setModuleInjector = (injector: Injector): void => {
    const token = Math.random().toString();
    // eslint-disable-next-line @typescript-eslint/dot-notation
    epicModuleInjectorTokenContainer['token'] = token;
    // eslint-disable-next-line @typescript-eslint/dot-notation
    epicDependencies['moduleInjectors'] =
        // eslint-disable-next-line @typescript-eslint/dot-notation
        epicDependencies['moduleInjectors'] ?? [];
    // eslint-disable-next-line @typescript-eslint/dot-notation
    epicDependencies['moduleInjectors'][token] = injector;
};

export const getModuleInjector = (): Injector => {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const token = epicModuleInjectorTokenContainer['token'];
    // eslint-disable-next-line @typescript-eslint/dot-notation
    return epicDependencies['moduleInjectors'][token];
};
